<template>
  <v-data-table
    v-if="company && company.members"
    :headers="table_headers"
    :items="company.members"
    :search="search"
    hide-actions
  >
    <template v-slot:items="props">
      <tr>
        <td class="text-xs-left">{{ props.index + 1 }}</td>
        <td class="text-xs-left">
          {{ props.item.name ? props.item.name : props.item.temp_user_name }}
          <v-chip
            small
            v-if="props.item.id == user.id"
            color="lightteal"
            outline
            >{{ $t("rms.you") }}</v-chip
          >
        </td>
        <td class="text-xs-left">
          {{ DEFINES.ROLE_STR[props.item.pivot.role] }}
        </td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.phone"></span>
          <span v-else>---</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AdminCompanyProfileMembers",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      search: null,
      table_headers: [
        {
          text: i18n.t("rms.table.header.sn"),
          align: "left",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("rms.table.header.name"),
          align: "left",
          sortable: false,
        },
        {
          text: i18n.t("rms.table.header.role"),
          align: "left",
          sortable: false,
        },
        { text: i18n.t("rms.table.header.email"), sortable: false },
        { text: i18n.t("rms.table.header.phone"), sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](this.company.id);
    },
  },
};
</script>

<style>
</style>
